// These are the locales that are supported by Bazaarvoice.
// List from https://knowledge.bazaarvoice.com/wp-content/conversations/en_US/Learn/localization.html

export type BazaarvoiceLocale = (typeof bazaarvoiceLocales)[number];

export const fixBazaarVoiceLocale = (
  locale: string,
): BazaarvoiceLocale | undefined => {
  switch (locale) {
    case "en":
    case "en-HK":
    case "en-AU":
      return "en_GB";
    case "default":
      return "en_US";
  }

  locale = locale.replace("-", "_");

  if (locale.length === 2) {
    locale = `${locale}_${locale.toUpperCase()}`;
  }

  return isBazaarvoiceLocale(locale) ? locale : undefined;
};

const isBazaarvoiceLocale = (locale: string): locale is BazaarvoiceLocale =>
  bazaarvoiceLocales.includes(locale as BazaarvoiceLocale);

const bazaarvoiceLocales = [
  "it_IT",
  "sv_SE",
  "en_CA",
  "en_GB",
  "en_US",
  "es_ES",
  "fr_CA",
  "fr_FR",
  "nl_NL",
  "de_DE",
] as const;
